import { configureStore } from '@reduxjs/toolkit';
import createReducer from './rootReducer';

import indexedDbStorage from './indexedDbStorage';
import { persistReducer, persistStore } from 'redux-persist';

const persistConfig = {
  key: 'root1',
  storage: indexedDbStorage,
};

const buildWhitelist = (asyncReducers = {}) => {
  const baseKeys = ['app', 'orders'];
  const asyncKeys = Object.keys(asyncReducers);
  return Array.from(new Set([...baseKeys, ...asyncKeys]));
};

const persistedReducer = (asyncReducers) => {
  const reducerWhitelist = buildWhitelist(asyncReducers);
  const config = {
    ...persistConfig,
    whitelist: reducerWhitelist,
  };

  return persistReducer(config, createReducer(asyncReducers));
};

// const productPersistConfig = {
//   key: 'productTest',
//   storage: indexedDbStorage, // ✅ استخدام IndexedDB فقط لهذه البيانات
// };
// const productTestReducer = persistReducer(productPersistConfig, createReducer().productTest);


if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./rootReducer', () => {
    const newRootReducer = require('./rootReducer').default;
    store.replaceReducer(newRootReducer.createReducer());
  });
}

const middlewares = [];

if (process.env.NODE_ENV === 'development') {
  const { createLogger } = require(`redux-logger`);
  const logger = createLogger({ collapsed: (getState, action, logEntry) => !logEntry.error });

  middlewares.push(logger);
}

const store = configureStore({
  // reducer: createReducer(),
  reducer: persistedReducer(),
  // reducer: {
  //   root: persistedReducer, // ✅ تخزين عادي في `localStorage`
  //   productTest: productTestReducer, // ✅ تخزين البيانات الضخمة في `IndexedDB`
  // },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  devTools: process.env.NODE_ENV === 'development',
});

store.asyncReducers = {};

export const injectReducer = (key, reducer) => {
  if (store.asyncReducers[key]) {
    return false;
  }
  store.asyncReducers[key] = reducer;
  // store.replaceReducer(createReducer(store.asyncReducers));
  store.replaceReducer(persistedReducer(store.asyncReducers));
  return store;
};

export const persistor = persistStore(store);

export default store;
